module.exports = __webpack_public_path__ + "img/5-cartoon-content.8505676a.jpg";